import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import { EXPORT_BANNER_HEIGHT } from '@src/constants/project';
import Typography from '@src/new-components/Typography';
import { formatExportLabel } from '@src/services/project';

const BANNER_STYLE = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: COLOR.packageExpiringSoon,
  height: EXPORT_BANNER_HEIGHT,
  padding: '0 24px',
  flexShrink: 0,
  overflow: 'hidden',
};

// Full-width orange banner shown while a project export (pptx/video/audio)
// is in progress. The project cannot be edited until the export finishes.
const ExportingBanner = ({ isExporting, formats }) => {
  const { t } = useTranslation();

  if (!isExporting || !formats?.length) return null;

  return (
    <div style={BANNER_STYLE}>
      <Typography variant="body-14-medium" color={COLOR.white} align="center">
        {t('exportingProjectBanner', { format: formatExportLabel(formats) })}
      </Typography>
    </div>
  );
};

export default ExportingBanner;
